module.exports = __webpack_public_path__ + "img/link-horizontal.13299b23.svg";